import { InterfaceAbi } from "ethers";
import { Networks } from "../networks/networks.service";
import { IErc20ContractData } from './evm-erc20-contract-factory.service';

export abstract class BaseContractFactory
{
    abstract create(
        _address: string,
        _network: Networks,
        _abi?: InterfaceAbi,
        _nameData?: { symbol: string, name: string; },
        _explorer?: string,
        implicit?: boolean
    ): Promise<IErc20ContractData>;
}
